angular.module('SpidApp')

.factory('CashService', 
				['Restangular', 'ConfigService', 
function (Restangular,   ConfigService) {
	var CashService = {
		save: function (str, params) {
			if (!str) {
				throw 'Cash::save() - Missing parameters'
			}

			return ConfigService.all().then(function (config) {
				return Restangular.all('cash').post({
					state      : str,
					vacationId : params.vacationId,
					agencyId   : config.agencyId
				})
			})
		}
	}

	return CashService
}])